import { Dimensions, StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const styles = StyleSheet.create({
  modalStyle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerFlex: {
    flex: 1,
  },
  container: {
    backgroundColor: colors.lightGrey,
    paddingVertical: 5,
    borderRadius: 2,
    width: IS_WEB
      ? Dimensions.get('window').width / 2.5
      : Dimensions.get('window').width / 1.5,
  },
  header: {
    borderBottomWidth: 1,
    borderBottomColor: colors.darkGrey,
    paddingVertical: 10,
  },
  headerText: {
    fontSize: 20,
    color: colors.darkGrey,
    textAlign: 'center',
  },
  body: {
    padding: 10,
  },
  setsContainer: {
    borderWidth: 1,
    borderColor: colors.darkGrey,
  },
  setItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
  },
  selectedSetItem: {
    backgroundColor: colors.grey,
  },
  setItemText: {
    fontSize: 16,
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    flex: 1,
  },
  buttonContainer: {
    padding: 10,
    flex: 1,
    borderRadius: 2,
  },
  buttonText: {
    fontWeight: '500',
    textAlign: 'center',
  },
  backBtn: {
    backgroundColor: colors.grey,
  },
  backText: {
    color: appTheme.textColor,
  },
  nextBtn: {
    backgroundColor: appTheme.primary,
  },
  nextText: {
    color: colors.white,
  },
  radio: {
    borderWidth: 2,
    borderRadius: 50,
    borderColor: colors.darkGrey,
    height: 30,
    width: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioActive: {
    height: 17,
    width: 17,
    backgroundColor: appTheme.primary,
    borderRadius: 50,
  },
  marginRight: {
    marginRight: 5,
  },
  separator: {
    width: '100%',
    height: 0,
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: colors.darkGrey,
  },
});
